import { render } from "./SelectableTags.vue?vue&type=template&id=289b5719"
import script from "./SelectableTags.vue?vue&type=script&lang=js"
export * from "./SelectableTags.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__